import { SketchRelationKind } from '../../sketch/solver/constraint/relation-compatibility/SketchRelationKinds';
import type { MarkerVisualStyle } from './SketchRelationMarkerTypes';
import { RelationMarkerVisualState } from './SketchRelationMarkerTypes';

/** SVG 背景颜色占位符。 */
export const SVG_BG_COLOR_TOKEN = '__BG_COLOR__';
/** SVG 图形颜色占位符。 */
export const SVG_GLYPH_COLOR_TOKEN = '__GLYPH_COLOR__';

/** 关系标签视觉样式映射。 */
export const MARKER_VISUAL_STYLE_MAP: Record<RelationMarkerVisualState, MarkerVisualStyle> = {
    [RelationMarkerVisualState.Default]: {
        backgroundColor: '#000000',
        glyphColor: '#000000',
    },
    [RelationMarkerVisualState.MenuSelected]: {
        backgroundColor: '#57adff',
        glyphColor: '#1f2f6f',
    },
    [RelationMarkerVisualState.ClickSelected]: {
        backgroundColor: '#00ff00',
        glyphColor: '#111111',
    },
    [RelationMarkerVisualState.Hover]: {
        backgroundColor: '#8fd0ff',
        glyphColor: '#1f2f6f',
    },
};

/** SVG 模板路径映射。 */
export const SVG_URL_MAP: Partial<Record<SketchRelationKind, string>> = {
    [SketchRelationKind.Horizontal]: '/textures/sketch/relation/rectangle-relation-horizontal.svg',
    [SketchRelationKind.Vertical]: '/textures/sketch/relation/rectangle-relation-vertical.svg',
    [SketchRelationKind.Perpendicular]: '/textures/sketch/relation/rectangle-relation-perpendicular.svg',
    [SketchRelationKind.Tangent]: '/textures/sketch/relation/rectangle-relation-tangent.svg',
    [SketchRelationKind.Parallel]: '/textures/sketch/relation/rectangle-relation-parallel.svg',
    [SketchRelationKind.Equal]: '/textures/sketch/relation/rectangle-relation-equal.svg',
    [SketchRelationKind.Collinear]: '/textures/sketch/relation/rectangle-relation-collinear.svg',
    [SketchRelationKind.Coradial]: '/textures/sketch/relation/rectangle-relation-coradial.svg',
    [SketchRelationKind.Concentric]: '/textures/sketch/relation/rectangle-relation-concentric.svg',
    [SketchRelationKind.Midpoint]: '/textures/sketch/relation/rectangle-relation-midpoint.svg',
    [SketchRelationKind.Intersection]: '/textures/sketch/relation/rectangle-relation-intersection.svg',
    [SketchRelationKind.Coincident]: '/textures/sketch/relation/rectangle-relation-coincident.svg',
    [SketchRelationKind.Symmetric]: '/textures/sketch/relation/rectangle-relation-symmetric.svg',
    [SketchRelationKind.Fix]: '/textures/sketch/relation/rectangle-relation-fix.svg',
    [SketchRelationKind.FixSlot]: '/textures/sketch/relation/rectangle-relation-fix-slot.svg',
    [SketchRelationKind.Pierce]: '/textures/sketch/relation/rectangle-relation-pierce.svg',
    [SketchRelationKind.MergePoints]: '/textures/sketch/relation/rectangle-relation-merge-points.svg',
    [SketchRelationKind.OnEdge]: '/textures/sketch/relation/rectangle-relation-on-edge.svg',
    [SketchRelationKind.OnPlane]: '/textures/sketch/relation/rectangle-relation-on-plane.svg',
    [SketchRelationKind.OnSurface]: '/textures/sketch/relation/rectangle-relation-on-surface.svg',
    [SketchRelationKind.TangentToFace]: '/textures/sketch/relation/rectangle-relation-tangent-to-face.svg',
    [SketchRelationKind.EqualCurvature]: '/textures/sketch/relation/rectangle-relation-equal-curvature.svg',
    [SketchRelationKind.EqualCurveLength]: '/textures/sketch/relation/rectangle-relation-equal-curve-length.svg',
    [SketchRelationKind.TwiceDistance]: '/textures/sketch/relation/rectangle-relation-twice-distance.svg',
    [SketchRelationKind.EqualSlot]: '/textures/sketch/relation/rectangle-relation-equal-slot.svg',
    [SketchRelationKind.TorsionContinuity]: '/textures/sketch/relation/rectangle-relation-torsion-continuity.svg',
    [SketchRelationKind.ParallelToYZ]: '/textures/sketch/relation/rectangle-relation-parallel-to-yz.svg',
    [SketchRelationKind.ParallelToZX]: '/textures/sketch/relation/rectangle-relation-parallel-to-zx.svg',
    [SketchRelationKind.AlongZ]: '/textures/sketch/relation/rectangle-relation-along-z.svg',
    [SketchRelationKind.Patterned]: '/textures/sketch/relation/rectangle-relation-patterned.svg',
};
